import * as React from "react";

import I18n from "lib/I18n";
import { Graph } from "../Graph";
import { Stat } from "../../store";

interface PieProps {
  stats: Stat[];
  titleSelected: (titleId: number, titleName: string) => void;
}

export function Pie(props: PieProps) {
  const { stats, titleSelected } = props;

  const sliceClicked = (e: unknown) => {
    if (typeof e != "object" || !e) {
      return;
    }
    if (!("dataItem" in e)) {
      return;
    }
    if (typeof e.dataItem != "object" || !e.dataItem) {
      return;
    }
    if (!("dataContext" in e.dataItem)) {
      return;
    }
    if (typeof e.dataItem.dataContext != "object" || !e.dataItem.dataContext) {
      return;
    }
    if (!("titleId" in e.dataItem.dataContext)) {
      return;
    }
    if (typeof e.dataItem.dataContext.titleId != "number") {
      return;
    }
    if (!("titleName" in e.dataItem.dataContext)) {
      return;
    }
    if (typeof e.dataItem.dataContext.titleName != "string") {
      return;
    }
    titleSelected(
      e.dataItem.dataContext.titleId,
      e.dataItem.dataContext.titleName,
    );
  };

  const prepareChartData = () => {
    const chartData: {
      [index: string]: {
        titleId: number;
        titleName: string;
        sector: string;
        cost: number;
      };
    } = {};
    stats.forEach((stat) => {
      const titleId = stat.id;
      if (!chartData[titleId]) {
        const titleName = stat.name;
        chartData[titleId] = {
          titleId,
          titleName,
          sector: titleName,
          cost: 0,
        };
      }
      chartData[titleId].cost += stat.cost;
    });
    return Object.keys(chartData)
      .map((key) => chartData[key])
      .sort((c1, c2) => {
        return c2.cost - c1.cost;
      });
  };

  const prepareConfig = () => {
    const chartData = prepareChartData();
    return {
      pathToImages: "/assets/amcharts/",
      type: "pie",
      theme: "light",
      valueField: "cost",
      titleField: "sector",
      startDuration: 0,
      innerRadius: 70,
      pullOutRadius: 20,
      marginTop: 30,
      allLabels: [
        {
          y: "50%",
          align: "center",
          size: 25,
          bold: true,
          text: `$${chartData
            .map((c) => c.cost)
            .reduce((p, c) => p + c, 0)
            .toPrecision(3)}`,
          color: "#555",
        },
        {
          y: "44%",
          align: "center",
          size: 15,
          text: I18n.t("bigquery_query_jobs_stats_viewer.label.sum"),
          color: "#555",
        },
      ],
      dataProvider: chartData,
      listeners: [
        {
          event: "clickSlice",
          method: sliceClicked,
        },
      ],
    };
  };

  return (
    <div>
      <Graph
        id="bigquery-query-logs-stats-viewer-pie"
        config={prepareConfig()}
      />
    </div>
  );
}
